import projection from '../generated/pwd514f1.json';
import { AcceptanceManifest } from '../types';
export const pwd514f1AcceptanceManifest = projection as AcceptanceManifest;
